export default __webpack_public_path__ + "static/el_dora-3a2b9f6a50799e617024384ded1045d1.png";